import { render, staticRenderFns } from "./chiocecolor.vue?vue&type=template&id=7182015c&scoped=true&"
import script from "./chiocecolor.vue?vue&type=script&lang=js&"
export * from "./chiocecolor.vue?vue&type=script&lang=js&"
import style0 from "./chiocecolor.vue?vue&type=style&index=0&id=7182015c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7182015c",
  null
  
)

export default component.exports